// const routes = [
//   {
//       path: '/videoBack',
//       name: 'dhvideoBack',
//       redirect: "/videoBack/index",
//       component: () => import('@src/modules/dhVideoBack/main'),
//       meta: {
//           requireAuth: true,
//       },
//       children: [
//           {
//               path: 'index',
//               name: 'dhVideoBackIndex',
//               component: () => import('@ISS/dhVideoBack/view/index'),
//               meta: {
//                   requireAuth: true,
//                   routerAlive: false
//               },
//           },
//       ],
//   },
// ]

// export default routes

const routes = [
    {
        path: '/videoBack',
        name: 'recordVideo',
        component: () => import('./view/index.vue'),
        meta: {
            requireAuth: true,
            routerAlive: false
        }
    }
]

export default routes